<div class="flg-display">
<mat-chip-set *ngIf="flags && flags.length > 0">
    <mat-chip *ngFor="let flag of flags" 
              [matTooltip]="getFlagInfo(flag)?.description || ''"
              matTooltipClass="flag-tooltip">
      {{ getFlagInfo(flag)?.label }}
    </mat-chip>
</mat-chip-set>
</div>